import type { OrderSetupDetailResponseDto } from "Infrastructure/Api/Api";
import { useDeleteOrderSetupMutation } from "Settings/Modules/OrderSetup/Api/Mutation/useDeleteOrderSetupMutation";
import { DeleteSetupModal } from "Settings/Modules/OrderSetup/Components/Form/Modal/DeleteSetupModal";
import { SettingsPaths } from "Settings/Routes/Routing";
import { Delete } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { type FC, useState } from "react";
import { useNavigate } from "react-router";

type Props = {
	orderSetup: OrderSetupDetailResponseDto;
	marketId: number;
	verticalId: number;
};

export const OrderSetupDeleteWidget: FC<Props> = ({
	orderSetup,
	marketId,
	verticalId,
}) => {
	const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
	const navigate = useNavigate();
	const { mutate, isPending } = useDeleteOrderSetupMutation();

	const handleSubmit = () => {
		mutate(orderSetup.id, {
			onSuccess: () => {
				setIsConfirmationModalOpen(false);
				navigate(SettingsPaths.OrderSetup.path(marketId, verticalId));
			},
			onError: () => {
				setIsConfirmationModalOpen(false);
			},
		});
	};

	return (
		<Stack>
			<DeleteSetupModal
				isOpen={isConfirmationModalOpen}
				handleClose={() => setIsConfirmationModalOpen(false)}
				onSubmit={handleSubmit}
				isPending={isPending}
			/>
			<Button
				size="small"
				color="error"
				startIcon={<Delete />}
				sx={{ alignSelf: "flex-end" }}
				onClick={() => setIsConfirmationModalOpen(true)}
			>
				Delete setup
			</Button>
		</Stack>
	);
};
